import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceHide18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_495)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.06349 4.0028L1.53035 0.469666L0.46969 1.53033L3.93933 4.99997L0.776516 8.16278C0.316357 8.62294 0.316356 9.39231 0.776516 9.85247C3.11817 12.1941 5.36707 15.278 8.99996 15.278C10.4249 15.278 11.8035 14.8278 12.9454 14.006L16.4697 17.5303L17.5304 16.4697L14.0683 13.0076L17.2234 9.85247C17.6836 9.39232 17.6836 8.62294 17.2234 8.16278C14.8818 5.82112 12.6329 2.73724 8.99996 2.73724C7.57871 2.73724 6.20365 3.18515 5.06349 4.0028ZM4.99999 6.06063L2.05299 9.00763C4.00283 10.9575 5.96465 13.778 8.99996 13.778C10.0255 13.778 11.0201 13.4782 11.8666 12.9272L10.8874 11.948C7.93457 13.8424 4.05346 10.2276 6.05196 7.1126L4.99999 6.06063ZM7.11263 6.05195L6.14265 5.08196C6.98716 4.53481 7.97822 4.23724 8.99996 4.23724C12.0353 4.23724 13.9971 7.05779 15.9469 9.00763L13.0076 11.9469L11.948 10.8873C13.9464 7.77231 10.0654 4.15767 7.11263 6.05195ZM9.78108 10.8417C8.21399 11.5072 6.4687 9.84266 7.15825 8.21888L9.78108 10.8417ZM8.21893 7.15825L10.8417 9.78103C11.5311 8.15731 9.78598 6.49288 8.21893 7.15825Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_495'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

AppearanceHide18.displayName = 'AppearanceHide18';
export default AppearanceHide18;
